'use client';

import styles from './index.module.scss';
import IconButton from "@/app/_components/Shared/IconButton";
import {useRouter} from "nextjs-toploader/app";

export const ServiceHeader = ({
    title,
    description,
    image,
    buttonText = "Start Now",
    buttonLink = "/contact",
    containerClassName = "",
    children,
}) => {
    const router = useRouter();

    const handleButtonClick = () => {
        router.push(buttonLink);
    };

    return (
        <div className={`${styles.container} ${containerClassName}`}>
            {image}
            <h1 className={styles.title}>
                {title}
            </h1>
            {
                description && (
                    <p className={styles.description}>
                        {description}
                    </p>
                )
            }
            {
                buttonText && (
                    <IconButton onClick={handleButtonClick}>
                        {buttonText}
                    </IconButton>
                )
            }
            {children}
        </div>
    );
}